export default __webpack_public_path__ + "static/media/01.e4566982.jpg";